export default __webpack_public_path__ + "static/media/chevron-right.88153a5d.svg";